import { Vendor } from "@finway-group/shared/lib/models"
import { t } from "i18next"
import React from "react"
import { formatPhoneNumberIntl } from "react-phone-number-input"

interface VendorContactDetailsProps {
    vendor: Vendor
}

export const VendorContactDetails = ({ vendor }: VendorContactDetailsProps) => {
    const renderStreetAddress = () => {
        if (vendor.streetName && vendor.streetNumber) {
            return `${vendor.streetName} ${vendor.streetNumber}`
        }
        if (vendor.streetName) {
            return vendor.streetName
        }
        if (vendor.streetNumber) {
            return vendor.streetNumber
        }

        return "-"
    }

    return (
        <>
            <ul className="description-list">
                <li>
                    <span className="title">{t("label:street_address")}</span>
                    <span className="text max-w-200">{renderStreetAddress()}</span>
                </li>
                <li>
                    <span className="title">{t("label:city")}</span>
                    <span className="text truncate max-w-200">{vendor.city || "-"}</span>
                </li>
                <li>
                    <span className="title">{t("label:zip")}</span>
                    <span className="text truncate max-w-200">{vendor.zip || "-"}</span>
                </li>
                <li>
                    <span className="title">{t("label:country")}</span>
                    <span className="text truncate max-w-200">{vendor.country || "-"}</span>
                </li>
                <li>
                    <span className="title">{t("label:contact_person")}</span>
                    <span className="text truncate max-w-200">{vendor.contactPersonName || "-"}</span>
                </li>
                <li>
                    <span className="title">{t("label:email")}</span>
                    <span className="text truncate max-w-200">{vendor.contactPersonEmail || "-"}</span>
                </li>
                <li>
                    <span className="title">{t("label:phone")}</span>
                    <span className="text truncate max-w-200">{formatPhoneNumberIntl(vendor.contactPersonPhone) || "-"}</span>
                </li>
            </ul>
        </>
    )
}
